import React from "react";

import Nav from "react-bootstrap/Nav";

import { DashboardMenu } from "./DashboardMenu";
import { SettingsMenu } from "./SettingsMenu";
import { PackageMenu } from "./PackageMenu";
import { FlexPackMenu } from "./FlexPackMenu";

import "./sidenav.scss";

export default function Sidenav() {
  const isDashboard = /\/event\b/.test(window.location);
  const isPackage = /\/package\b/.test(window.location.pathname);
  const isFlexPack = /\/flex-package\b/.test(window.location);
  const isSettings = /\/settings\b/.test(window.location);

  return (
    <>
      <aside
        id="sidebarMenu"
        className={`sidebar ${isDashboard || isPackage || isFlexPack ? "sidebar--with-banner" : ""}`}
      >
        <div className="sidebar-wrapper">
          <Nav
            as="nav"
            className="position-sticky"
            activeKey={window.location.pathname}
          >
            {isDashboard && <DashboardMenu />}
            {isFlexPack && <FlexPackMenu />}
            {isPackage && <PackageMenu />}
            {isSettings && <SettingsMenu />}
          </Nav>
        </div>
      </aside>
    </>
  );
}
